import React, { useContext, useEffect, useState } from 'react';
import './MyOrders.css';
import { StoreContext } from '../context/StoreContext';
import { RecommendationContext } from '../context/RecommendationContext';
import axios from 'axios';
import { images } from '../images/images';

export default function MyOrders() {
    const { url, token, bev_list } = useContext(StoreContext);
    const { setRecommendation } = useContext(RecommendationContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.name || "Guest";


    const fetchOrders = async () => {
        try {
            setLoading(true);
            console.log('Fetching orders with token:', token);
            const response = await axios.post(url + "/api/order/userorders", {}, { headers: { token } });
            const orders = response.data.data;
            console.log('Fetched orders:', orders);

            if (Array.isArray(orders)) {
                setData(orders);
                if (orders.length > 0) {
                    const mostRecentOrder = orders[0];
                    const recentSugarLevel = mostRecentOrder.items[0].sugar_level;
                    generateRecommendation(recentSugarLevel);
                }
            } else {
                setData([]);
            }
        } catch (err) {
            setError(err.message);
            console.error('Error fetching orders:', err);
        } finally {
            setLoading(false);
        }
    };

    // Example logic to recommend beverages with lower sugar level than previous order
    const generateRecommendation = (previousSugarLevel) => {
      if (bev_list && bev_list.length > 0) {
        const recommendedDrink = bev_list.find(beverage => beverage.sugar < previousSugarLevel);
        setRecommendation(recommendedDrink || null);
      }
    };

    useEffect(() => {
        if (token) {
            fetchOrders();
        }
    }, [token]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="my-orders">
            <h1>WELCOME, {userName.toUpperCase()}</h1>
            <br />
            <h2>{userName.toUpperCase()}'s Orders</h2>
            <div className="container">
                {data.length > 0 ? (
                    data.map((order, index) => (
                        <div key={index} className="my-orders-order">
                            <img src={images.parcel_icon} alt="Parcel Icon" />
                            <p>{new Date(order.date).toISOString().split('T')[0]}</p>
                            <p>
                                {order.items && order.items.length > 0 ? (
                                    order.items.map((item, itemIndex) => (
                                        <span key={itemIndex}>
                                            {item.name} x {item.quantity}{itemIndex === order.items.length - 1 ? '' : ', '}
                                        </span>
                                    ))
                                ) : (
                                    "No items"
                                )}
                            </p>
                            <p>P{order.amount}.00</p>
                            <p>Items: {order.items ? order.items.length : 0}</p>
                            <p><span>&#x25cf;</span> <b>{order.status}</b></p>
                            <button onClick={fetchOrders}>Track Order</button>
                        </div>
                    ))
                ) : (
                    <p>No items</p>
                )}
            </div>
        </div>
    );
}
